// logo size: 676x164

export const HEADER_LOGO_WIDTH_DESKTOP = 230;
export const HEADER_LOGO_WIDTH_MOBILE = 117;
export const HEADER_LOGO_HEIGHT_DESKTOP = 59;
export const HEADER_LOGO_HEIGHT_MOBILE = 32;
